/**
 * Helpers da tela de CRM (pipeline de Leads).
 *
 * - iniciais/corAvatar/tempoRel: identicos aos da Lista de Orcamentos
 *   (mantidos locais para o CRM nao depender de helpers da tela de orcamento).
 * - exportarCrm: leva as linhas de GET /api/crm/leads/exportar ao shape
 *   {titulo, resumo, secoes} que utils/exportacao consome (modelo de
 *   exportarRelatorios.js). O mapeamento puro fica em crmExportacao.js.
 * - Link do WhatsApp: utils/leadFormat.linkWhatsapp (a regua unica de
 *   telefone). O duplicado que vivia aqui errava o DDD 55.
 */
import { fmtMoeda } from "../Orcamentos/helpers";
import { dataLocalDe } from "../../utils/dinheiro";
import { salvarCSV, salvarExcel, salvarPDF } from "../../utils/exportacao";

import {
  COLUNAS_COMPLETAS,
  COLUNAS_PDF,
  linhaDeExportacao,
  resumoDaExportacao,
} from "./crmExportacao";

const AVATAR_BG = [
  "var(--info-solid)",
  "var(--success-solid)",
  "var(--warning-solid)",
  "var(--accent)",
  "var(--danger-solid)",
];

export function iniciais(nome) {
  const p = (nome || "").trim().split(/\s+/);
  return ((p[0]?.[0] || "") + (p[1]?.[0] || "")).toUpperCase() || "?";
}

export function corAvatar(nome) {
  let h = 0;
  for (const c of nome || "") h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return AVATAR_BG[h % AVATAR_BG.length];
}

export function tempoRel(iso) {
  if (!iso) return "";
  const dias = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  if (dias <= 0) return "hoje";
  if (dias === 1) return "ha 1d";
  if (dias < 30) return `ha ${dias}d`;
  // Fallback simples (sem importar fmtData só pra isso)
  try {
    return (dataLocalDe(iso) || new Date(NaN)).toLocaleDateString("pt-BR");
  } catch {
    return "";
  }
}

const SAVERS = {
  pdf: salvarPDF,
  excel: salvarExcel,
  csv: salvarCSV,
};

/**
 * Exporta o pipeline de leads em PDF / Excel / CSV.
 *
 * @param {"pdf"|"excel"|"csv"} formato
 * @param {object} dados
 * @param {Array}  dados.leads     linhas de `exportarLeads` (LeadExportSerializer)
 * @param {object} [dados.metricas] {total, soma, etapas}
 */
export function exportarCrm(formato, { leads = [], metricas = {} } = {}) {
  const saver = SAVERS[formato];
  if (!saver) throw new Error(`Formato desconhecido: ${formato}`);

  const linhas = leads.map(linhaDeExportacao);
  const colunasExport = formato === "pdf" ? COLUNAS_PDF : COLUNAS_COMPLETAS;

  return saver({
    titulo: "CRM — Pipeline de Leads",
    resumo: resumoDaExportacao(linhas, metricas),
    secoes: [
      {
        id: "leads",
        label: "Leads",
        columns: colunasExport,
        rows: linhas,
      },
    ],
  });
}

// Reexport util para quem importar daqui.
export { fmtMoeda };
